import React from 'react';
import '../../../styles/landingPage.css';
import '../../../styles/artworks.css';
import '../../../styles/common_elements.css';
// import ComponentSlider from "@kapost/react-component-slider";
import Button from 'react-bulma-components/lib/components/button';
// import Grid from '@material-ui/core/Grid';
import {inject, observer} from 'mobx-react';
import CategorySection from '../../sectionHolders/categorySectionHolder'
import ArtistOfTheMonthSection from '../../sectionHolders/artistOfTheMonthSection'
import CommissionRequestSection from '../../sectionHolders/comissionRequestSection'
import SubscribeMasterpiece from '../../sectionHolders/subscribe-section'
import ArtistsAndArtworksSection from '../../sectionHolders/artistsAndArtworksCardSection'
import {Redirect} from 'react-router-dom';
import {
    validateIfInputHasCharacters,
    validateIfInputHasSpaces,
    validateIfInputHasUpperCaseLetter,
    validateIfInputHasYourMasterpieces,
    validateInputLength
} from "../../../helpers/validationChecks";
import LandingPageIntroSection from '../../sectionHolders/landingPageIntroSection'
import BlogSection from '../../sectionHolders/blogSection'
import Agent from '../../../api/agent';
import Helmet from 'react-helmet';
import ReactGA from "react-ga";
// import { url } from 'inspector';
var qs = require('qs')

@inject('userStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'categoryPageArtworksStore')
@observer
export default class landingPage extends React.Component {
    constructor(props) {
        super(props);
        this.artworksRef = React.createRef();

        this.state = {
            index: 0,
            liked: false,
            viewAll: false,
            wantsToJoinThePlatform: false,
            wantsToBrowseArtworks: false,
            wantsToBrowseCategory: false,
            featuredArtworksList: "",
            fromArtistsYouFollow: "",
            country: ""
        }
    }

    handleSignUpClick() {
        this.props.navigatorStore.openSignUpModal()
    }

    selectCountry(item) {
        this.setState({
            changedSomething: true,
            // formInputs: {
            // ...this.state.formInputs,
            country: item
            // }
        })
    }

    componentWillReceiveProps(nextProps) {

        // console.log('identifier did monnt landingpage componentWillReceiveProps',
        // this.props.authStore.loginDone, nextProps.authStore.loginDone,
        // this.props.authStore.loginDonegetApi)

        if (localStorage.hasOwnProperty("userData") && nextProps.authStore.loginDonegetApi) {
            this.props.authStore.resetLoginDoneGetApi()
            // console.log("identifier did monnt landingpage componentWillReceiveProps calling api")
            Agent.generalData.blogApi()
                .then((res) => {
                    this.setState({
                        full_name: localStorage.getItem("full_name"),
                        blogInfo: res.data ? res.data.length ? res.data[0].data : res.data.data : false
                    }, () => {
                        // console.log("blogs information", this.state.blogInfo)
                    })
                })
            this.props.landingPageArtworksStore.getInitialArtworksByCategory({search: "YMC Unconventional"})
                .then((res) => {
                    if (res) {
                        // console.log("[look at response]", res)
                        this.setState({

                            featuredArtworksList: (res.data) ? res.data.data : {}
                        }, function () {
                            // console.log("[look at artworks state]", this.state.artworksList);
                            // console.log(this.state.response)
                        })
                    }
                })
            this.props.landingPageArtworksStore.getInitialArtworksByCategory({following: "True"}, true)
                .then((res) => {
                    // console.log("[look at response]", res)
                    if (res) {
                        this.setState({
                            logged_out: false,
                            fromArtistsYouFollow: (res.data) ? res.data.data : {}
                        }, function () {
                            // console.log("[look at artworks state]", this.state.fromArtistsYouFollow);
                            // console.log(this.state.response)
                            this.props.authStore.resetLoginDoneGetApi()
                        })
                    }
                });

            this.props.landingPageArtworksStore.getInitialArtworksByCategory()
                .then((res) => {
                    if (res) {
                        // console.log("[look at response]", res)
                        this.setState({

                            allArtworks: (res.data) ? res.data.data : {}
                        }, function () {
                            // console.log("[look at artworks state]", this.state.allArtworks);
                            // console.log(this.state.response)
                        })
                    }
                })

        }
    }

    /*  componentWillMount() {
         // console.log('identifier did monnt landingpage componentWillMount')
         if (localStorage.hasOwnProperty("userData")
         ) {
 
             this.props.userStore.pulluser().then((result) => {
                 // console.log("{this is pulled user}", result)
                 result.data[0]
 
                 if (!result.data[0].interests) {
                     // console.log("interests null")
                     this.setState({
                         onboardingOneIncomplete: true
                     })
                 }
                 if (!result.data[0].preferences) {
                     // console.log("preferences null")
                     this.setState({
                         onboardingTwoIncomplete: true
                     })
                 }
 
 
                 if (!result.data[0].full_name ||
                     !result.data[0].country ||
                     //  !response.data.user_profile[0].full_name || 
                     //  !response.data.user_profile[0].user.email || 
                     //  !response.data.user_profile[0].display_name || 
                     !result.data[0].display_name ||
                     result.data[0].display_name.length >= 30 ||
                     !result.data[0].primary_email ||
                     !result.data[0].preferred_currency
 
                 ) {
                     // console.log("profile null")
                     this.setState({
                         onboardingThreeIncomplete: true
                     })
                     // this.state.makeOnboardingThreeIncomplete()
                 }
 
             })
         }
     } */

    componentDidMount() {

        ReactGA.pageview('/Home screen');

        if (localStorage.hasOwnProperty("userData")
        ) {

            this.props.userStore.pulluser().then((result) => {
                // console.log("{this is pulled user}", result)
                result.data[0]

                // if (!result.data[0].interests) {
                //     // console.log("interests null")
                //     this.setState({
                //         onboardingOneIncomplete: true
                //     })
                // }
                // if (!result.data[0].preferences) {
                //     // console.log("preferences null")
                //     this.setState({
                //         onboardingTwoIncomplete: true
                //     })
                // }
                if (!result.data[0].display_name && !!result.data[0].old_display_name) {
                    if ((result.data[0].old_display_name) && !validateInputLength(result.data[0].old_display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && !validateIfInputHasSpaces(result.data[0].old_display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasCharacters(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasUpperCaseLetter(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasYourMasterpieces(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    var formData = new FormData();
                    if (this.state.formInputs) formData.append("display_name", this.state.formInputs.display_name)
                    // if (!!this.state.formInputs.display_name && (this.state.curr_display_name != this.state.formInputs.display_name))
                    this.props.userStore.validateDisplayName(formData)
                        .then((response) => {
                            // console.log(response)
                            if (response.error == "True") {
                                this.setState({
                                    onboardingThreeIncomplete: true,
                                    // formInputs: { ...this.state.formInputs, display_name: "" }
                                })
                                // this.props.navigatorStore.openErrorModal(response.data)
                                return;
                            } else {
                                this.setState({
                                    onboardingThreeIncomplete: true
                                })
                            }
                        })
                        .catch((err => {
                            this.setState({
                                onboardingThreeIncomplete: true,


                            })
                        }));
                }

                if (result.data[0].display_name) {
                    if ((result.data[0].display_name) && !validateInputLength(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && !validateIfInputHasSpaces(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasCharacters(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasUpperCaseLetter(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasYourMasterpieces(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                }

                if (!result.data[0].full_name ||
                    !result.data[0].country ||
                    //  !response.data.user_profile[0].full_name || 
                    //  !response.data.user_profile[0].user.email || 
                    //  !response.data.user_profile[0].display_name || 
                    !result.data[0].display_name ||
                    result.data[0].display_name.length >= 30 ||
                    !result.data[0].primary_email ||
                    !result.data[0].preferred_currency

                ) {
                    // console.log("profile null")
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    // this.state.makeOnboardingThreeIncomplete()
                }

            })


            this.props.landingPageArtworksStore.getInitialArtworksByCategory({search: "Featured"})
                .then((res) => {
                    if (res) {
                        // console.log("[look at response]", res)
                        this.setState({

                            featuredArtworksList: (res.data) ? res.data.data : {}
                        }, function () {
                            // console.log("[look at artworks state]", this.state.artworksList);
                            // console.log(this.state.response)
                        })
                    }
                })
            this.props.landingPageArtworksStore.getInitialArtworksByCategory({search: "YMC Unconventional"})
                .then((res) => {
                    if (res) {
                        // console.log("[look at response]", res)
                        this.setState({

                            unconventional_artworks: (res.data) ? res.data.data : {}
                        }, function () {
                            // console.log("[look at artworks state]", this.state.artworksList);
                            // console.log(this.state.response)
                        })
                    }
                })


            this.props.landingPageArtworksStore.getBrowseAllCategoryArtworks()
                .then((res) => {
                    if (res) {
                        // console.log("[look at response]", res)
                        this.setState({

                            allArtworks: (res.data) ? res.data.data : {}
                        }, function () {
                            // console.log("[look at artworks state]", this.state.allArtworks);
                            // console.log(this.state.response)
                        })
                    }
                })
            this.props.landingPageArtworksStore.getBrowseAllCategoryArtworks({following: "True"})
                .then((res) => {
                    // console.log("[look at response]", res)
                    if (res) {
                        this.setState({
                            fromArtistsYouFollow: (res.data) ? res.data.data : {}
                        }, function () {
                            // console.log("[look at artworks state]", this.state.fromArtistsYouFollow);
                            // console.log(this.state.response)
                        })
                    }
                });
            this.props.artistDetails.getAllArtistsCategory({search: "YMC Top"})
                .then((res) => {
                    if (res) {
                        // console.log("[look at response]", res)
                        this.setState({

                            topArtists: (res.data) ? res.data.data : {}
                        }, function () {
                            // console.log("[look at artworks state]", this.state.fromArtistsYouFollow);
                            // console.log(this.state.response)
                        })
                    }
                });
            this.props.landingPageArtworksStore.getInitialArtworksByCategoryPublic({search: "YMC Unconventional"})
                .then((res) => {
                    if (res) {
                        // console.log("[look at response]", res)
                        this.setState({
                            // logged_out : true,
                            unconventional_artworks: (res.data) ? res.data.data : {}
                        }, function () {
                            // console.log("[look at artworks state]", this.state.artworksList);
                            // console.log(this.state.response)
                        })
                    }
                })

            Agent.generalData.blogApi()
                .then((res) => {
                    this.setState({
                        blogInfo: res ? res.data ? res.data.length ? res.data[0].data : res.data.data : false : false
                    }, () => {
                        // console.log("blogs information", this.state.blogInfo)
                    })
                })
            Agent.generalData.AOTM()
                .then((res) => {
                    this.setState({
                        aotmInfo: res.data ? res.data.length ? res.data[0].data : res.data.data : false
                    }, () => {
                        // console.log("blogs information", this.state.blogInfo)
                    })
                })
        } else {
            // console.log('did monnt landingpage logged out ');
            // if (localStorage.hasOwnProperty("userData")) {
            Agent.generalData.AOTM()
                .then((res) => {
                    this.setState({
                        aotmInfo: !!res.data ? res.data.length ? res.data[0].data : res.data.data : false
                    }, () => {
                        // console.log("blogs information", this.state.blogInfo)
                    })
                })
            Agent.generalData.blogApi()
                .then((res) => {
                    this.setState({
                        blogInfo: !!res.data ? res.data.length ? res.data[0].data : res.data.data : false
                    })
                }, () => {
                    // console.log("blogs information", this.state.blogInfo)
                })
            this.props.landingPageArtworksStore.getInitialArtworksByCategoryPublic({search: "Featured"})
                .then((res) => {
                    if (res) {
                        // console.log("[look at response]", res)
                        this.setState({
                            // logged_out : true,
                            featuredArtworksList: (res.data) ? res.data.data : {}
                        }, function () {
                            // console.log("[look at artworks state]", this.state.artworksList);
                            // console.log(this.state.response)
                        })
                    }
                })
            this.props.landingPageArtworksStore.getInitialArtworksByCategoryPublic({search: "YMC Unconventional"})
                .then((res) => {
                    if (res) {
                        // console.log("[look at response]", res)
                        this.setState({
                            // logged_out : true,
                            unconventional_artworks: (res.data) ? res.data.data : {}
                        }, function () {
                            // console.log("[look at artworks state]", this.state.artworksList);
                            // console.log(this.state.response)
                        })
                    }
                })

            this.props.artistDetails.getAllArtistsCategoryPublic({search: "YMC Top"})
                .then((res) => {
                    if (res) {
                        // console.log("[look at response]", res)
                        this.setState({

                            topArtists: (res.data) ? res.data.data : {}
                        }, function () {
                            // console.log("[look at artworks state]", this.state.fromArtistsYouFollow);
                            // console.log(this.state.response)
                        })
                    }
                });
            // }
        }
    }

    handleViewAll(item) {
        switch (item) {
            case ("country"): {
                // this.props.categoryPageArtworksStore.setQuery({ search: "featured_artwork" }, "FEATURED ARTWORKS")


                this.setState({
                    viewAllArtistsCountry: true,
                    query: qs.stringify({search: this.state.country}),
                    artistKeyword: this.state.country,
                    title: "ARTISTS From" + this.state.country
                })
                break;
            }
        }

    }

    handleCategoryClick() {
        this.setState({
            wantsToBrowseCategory: true
        })
    }


    render() {
        // console.log("rendering landingpage", this.props.authStore.loginDone, this.props.authStore.loginDonegetApi, { state: this.state.onboardingThreeIncomplete, props: this.props.authStore.onboardingThreeIncomplete })
        if (this.state.viewAllArtistsCountry) {
            return (
                <Redirect push to={{pathname: `/allartists/${this.state.country}/country`}}/>
            )
        }
        if (
            localStorage.hasOwnProperty("userData") &&
            ((this.props.authStore.RegisterSuccess &&
                (!this.props.authStore.onboardingThreeIncomplete && !localStorage.getItem("registerDone")))
                || localStorage.getItem("just_registered"))

        ) {

            this.props.authStore.resetRegisterSuccess();
            localStorage.removeItem("just_registered")
            // console.log("registered, still ")
            // console.log("identifier redirecting to onboardingThree ", this.props.authStore.updateComplete, this.props.authStore.onboardingThreeIncomplete);
            return (
                <Redirect push to='/onboardingone'/>
            )
        }


        if (
            (window.localStorage.hasOwnProperty("userData") && !localStorage.getItem("registerDone") && !this.props.authStore.RegisterSuccess &&
                (this.state.onboardingThreeIncomplete || ((this.props.authStore.loginDone) &&
                    this.props.authStore.onboardingThreeIncomplete)))
            || localStorage.getItem("incompleteOnboardingThree")
        ) {
            // console.log("identifier redirecting to onboardingThree ", this.props.authStore.updateComplete, this.props.authStore.onboardingThreeIncomplete);
            this.props.authStore.resetLoginDone();
            this.props.authStore.resetUpdateComplete();
            localStorage.removeItem("incompleteOnboardingThree")
            return (
                <Redirect push to="/onboardingthree"></Redirect>
            )
        }


        const artworksForSpaces = [
            {
                value: "YMC Living",
                name: 'LIVING ROOM',
                path: require('../../../assets/livingroom_thumb.jpg'),
                src: "https://images-na.ssl-images-amazon.com/images/I/91t1zqhVPjL._SY500_.jpg"
            },
            {
                value: "YMC Bedroom",
                name: 'BEDROOM',
                path: require('../../../assets/bedroom_thumb.jpg'),
                src: "https://images-na.ssl-images-amazon.com/images/I/91t1zqhVPjL._SY500_.jpg"
            },
            {
                value: "YMC Cafes",
                name: 'CAFES',
                path: require('../../../assets/cafe_thumb.jpg'),
                src: "https://images-na.ssl-images-amazon.com/images/I/91t1zqhVPjL._SY500_.jpg"
            },
            {
                value: "YMC Workspaces",
                name: 'WORKSPACES',
                path: require('../../../assets/office_thumb.jpg'),
                src: "https://images-na.ssl-images-amazon.com/images/I/91t1zqhVPjL._S"
            }
        ]
        const trendingStyles = [
            {
                value: "T2019 Global Aesthetics",
                name: 'Global Aesthetics',
                path: require('../../../assets/artistic.jpg'),
                colored: true
            },
            {
                value: "T2019 Modern Botanical",
                name: 'Modern Botanical',
                path: require('../../../assets/botanicals.jpg'),
                colored: true
            },
            {
                value: "T2019 Black & White",
                name: 'Black & White',
                path: require('../../../assets/blacknwhite.jpg'),
                colored: true
            },
            {
                value: "T2019 Maximalism",
                name: 'Maximalism',
                path: require('../../../assets/maximalism.jpg'),
                colored: true
            }
        ]
        const ym_collection = [
            // { type: "search", value: "Pencil", name: 'PENCIL', path: require('../../../assets/pencil.jpg'), colored: true },
            {
                value: "YMC Portraits",
                name: 'PORTRAITS',
                path: require('../../../assets/portraits_thumb.jpg'),
                colored: true
            },
            {type: "search", value: "Oil", name: 'OIL', path: require('../../../assets/oil.jpg'), colored: true},
            {
                value: "YMC Abstract",
                name: 'ABSTRACT',
                path: require('../../../assets/abstract_thumb.jpg'),
                colored: true
            },
            {
                value: "YMC Landscape",
                name: 'LANDSCAPE',
                path: require('../../../assets/landscape_thumb.jpg'),
                colored: true
            },

        ]

        // console.log("popping", this.state.featuredArtworksList)

        if (!this.props.userStore.currentUser) {
            return (
                <div className="landing-page-container">
                    <Helmet>
                        {/* <title>{(artwork) ? artwork.length ? artwork[0].user_profile.display_name || artwork[0].user_profile.old_display_name : artwork.user_profile.display_name || artwork.user_profile.old_display_name : ""}</title> */}
                        <title>{"YourMasterpieces"}</title>

                        <meta name="description" content={`Artist on YourMasterpieces |  `}/>

                        <meta property="og:image"
                              content={"https://yourmasterpieces.com/images/masterpiece_logo.png"}></meta>
                    </Helmet>
                    <LandingPageIntroSection/>
                    <CategorySection title={"ARTWORKS FOR YOUR SPACES"}
                                     categoryData={artworksForSpaces} viewAll={true} colored={false}
                                     short_desc="Looking to decorate your space? We bring you art that not only decorates but defines your space. Art that feels complete and personal, curated only for you."
                                     viewAll={true} keyWord="spaces"/>
                    <CategorySection title={"TRENDING STYLES "} categoryData={trendingStyles} viewAll={false}
                                     colored={true}
                                     short_desc="We have curated the best artworks mirroring the latest trends in the art world for you. Check out what’s trending around the world!
                    " viewAll={true} keyWord="styles"/>
                    <ArtistsAndArtworksSection
                        short_desc={"Discover our carefully curated collection of original pieces of art - the only one of its kind to exist!"}
                        title="FEATURED ARTWORKS" colored={false} artistSection={false}
                        artworkData={this.state.featuredArtworksList} keyword="Featured"/>
                    {!!this.state.blogInfo && <BlogSection colored={true} blogInfo={this.state.blogInfo}/>}

                    <div className="container-rectangle-colored" style={{backgroundColor: "#ffff"}}>

                        <div style={{backgroundColor: "#ffff"}} className="col-md-12" ref={(section) => {
                            this.blog = section;
                        }}>

                            <div className="row">
                                <div className="col-md-6 justify-content-center border-vertical pb-25 ">

                                    <div className="who-we-are-title"> WHO WE ARE</div>
                                    <hr className="line-golden-who-we-are"></hr>


                                    <div className="who-we-are-content-golden">
                                        Started in 2016, the YourMasterpieces community now has over 20K artists across 142
                                        countries and grows stronger every day.

                                    </div>
                                    <div className="who-we-are-content-gray">
                                        YourMasterpieces is the first and only social platform for the non-digital fine
                                        art community with a vision to help artists to reach a global audience both
                                        digitally and tangibly. Artists, art collectors, art galleries, art educators
                                        and everyone who loves art have joined the platform.
                                    </div>
                                    <div className="col-md-12 text-center mt-25 mb-25 pb-15">
                                        <a href="/platform-for-everyone">
                                            <Button className="masterpieces-secondary-buttons">
                                                PLATFORM FOR EVERYONE
                                            </Button>
                                        </a>
                                    </div>

                                </div>

                                <div className="col-md-6 justify-content-center pb-25">

                                    <div className="who-we-are-title">WHO SHOULD JOIN US</div>
                                    <hr className="line-golden-who-we-are"></hr>
                                    <div className="who-we-are-content-golden">If you are an artist, an art collector or
                                        just someone who appreciates art, join YourMasterpieces today!

                                    </div>
                                    <div className="who-we-are-content-gray">You can buy and sell art, showcase art that
                                        you have created or just own. The YourMasterpieces platform is for everyone, for
                                        every individual around the globe who loves non-digital art.

                                    </div>
                                    <div className="col-md-12 text-center mt-25 mb-25 pb-15">
                                        <Button className="masterpieces-primary-buttons"
                                                onClick={this.handleSignUpClick.bind(this)}>JOIN THE PLATFORM
                                        </Button>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>


                    <ArtistsAndArtworksSection title="TOP ARTISTS" colored={true} artistSection={true}
                                               artistData={this.state.topArtists} keyword="YMC Top"/>
                    <ArtistOfTheMonthSection colored={false} AOTMdata={this.state.aotmInfo}/>
                    {/* <ArtistOfTheMonthSection colored={true}  AOTMdata={this.state.aotmInfo} /> */}
                    <CategorySection
                        short_desc="Discover irreplaceable original artworks picked by our curators only for you to give your interiors an aesthetic appeal that speaks of your style!"
                        title={"BROWSE ARTWORKS BY OUR COLLECTIONS"} categoryData={ym_collection} viewAll={true}
                        colored={true}
                        short_desc="Discover irreplaceable original artworks picked by our curators only for you to give your interiors an aesthetic appeal that speaks of your style!"
                        viewAll={true} keyWord="ym_collection"/>

                    <CommissionRequestSection full_name={this.state.full_name}/>
                    <SubscribeMasterpiece/>

                </div>
            )
        }
        if (this.props.userStore.currentUser) {
            return (
                <div className="landing-page-container">
                    <Helmet>
                        {/* <title>{(artwork) ? artwork.length ? artwork[0].user_profile.display_name || artwork[0].user_profile.old_display_name : artwork.user_profile.display_name || artwork.user_profile.old_display_name : ""}</title> */}
                        <title>{"YourMasterpieces"}</title>

                        <meta name="description" content={`Artist on YourMasterpieces |  `}/>

                        <meta property="og:image"
                              content={"https://yourmasterpieces.com/images/masterpiece_logo.png"}></meta>
                    </Helmet>
                    <LandingPageIntroSection/>
                    <ArtistsAndArtworksSection
                        title="LATEST ARTWORKS"
                        colored={false} artistSection={false}
                        artworkData={this.state.allArtworks}

                        keyword=""/>
                    <ArtistsAndArtworksSection
                        title="FROM ARTISTS YOU FOLLOW"
                        followingArtists={true}
                        colored={true} artistSection={false}
                        artworkData={this.state.fromArtistsYouFollow}
                        keyword="following"/>
                    {!!this.state.blogInfo &&
                    <BlogSection blogInfo={this.state.blogInfo}/>}
                    <CategorySection
                        title={"ARTWORKS FOR YOUR SPACES"}
                        categoryData={artworksForSpaces}
                        viewAll={true} colored={true}
                        short_desc="Looking to decorate your space? We bring you art that not only decorates but defines your space. Art that feels complete and personal, curated only for you."
                        viewAll={true} keyWord="spaces"/>
                    <CategorySection title={"TRENDING STYLES "} categoryData={trendingStyles} viewAll={false}
                                     colored={false} short_desc="Revised: We have curated the best artworks mirroring the latest trends in the art world for you. Check out what’s trending around the world!
" viewAll={true} keyWord="styles"/>
                    <ArtistsAndArtworksSection title="UNCONVENTIONAL ARTWORKS" colored={true} artistSection={false}
                                               artworkData={this.state.unconventional_artworks}
                                               keyword="YMC Unconventional"
                                               short_desc="If individualistic art is your type, discover thought provoking artworks that speak louder than a thousand words with this collection."/>
                    <ArtistsAndArtworksSection title="TOP ARTISTS" colored={false} artistSection={true}
                                               artistData={this.state.topArtists} keyword="YMC Top"/>
                    <ArtistOfTheMonthSection colored={true} AOTMdata={this.state.aotmInfo}/>
                    <CategorySection title={"BROWSE ARTWORKS BY OUR COLLECTIONS"} categoryData={ym_collection}
                                     viewAll={true} colored={true}
                                     short_desc="Discover irreplaceable original artworks picked by our curators only for you to give your interiors an aesthetic appeal that speaks of your style!"
                                     viewAll={true} keyWord="ym_collection"/>
                    <CommissionRequestSection full_name={localStorage.getItem("full_name")}/>
                    <SubscribeMasterpiece/>

                </div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Home/profile/landingPage.js